import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { FilterUiVersion } from '../useFilterUiVersion';
import type { VersionSwitchLabels } from '@components/framework/LegacyVersionSwitch';

interface Props {
  version: FilterUiVersion;
  onToggle: () => void;
  /** Say what the link switches when a page shows more than one of them; omit for the generic text. */
  labels?: VersionSwitchLabels;
}

/**
 * Temporary affordance letting a user flip between the classic filter grid and the new
 * chip-based filtering UI. Rendered only by tables that opt in via `enableFilterV2`.
 * Mirrors the shared `LegacyVersionSwitch` look (centered underlined link, `generic.*` keys)
 * used across supplier notifications, the dashboard, locality detail, etc.
 */
export const FilterUiVersionSwitch: React.FC<Props> = ({ version, onToggle, labels }) => {
  const { tr } = useTranslationLgs();
  const showLegacy = version === 'legacy';

  return (
    <div className="flex justify-center m-2">
      <button type="button" onClick={onToggle} className="text-xs text-content-tertiary underline hover:text-content-primary">
        {showLegacy
          ? labels?.toNew ?? tr('generic.switchToNewVersion', 'Switch to new version')
          : labels?.toLegacy ?? tr('generic.switchToLegacyVersion', 'Switch to legacy version')}
      </button>
    </div>
  );
};
